import React from "react";
import PropTypes from "prop-types";
import { NavLink, Route, Switch } from "react-router-dom";
import BoxOfficeAccessVoucher from "./BoxOfficeAccessVoucher";
import BoxOfficeSearch from "./BoxOfficeSearch";

class BoxOffice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    prop: PropTypes.string
  };

  render() {
    return (
      <div className="m-content">
        <div className="row justify-content-md-center">
          <div className="col-xl-8">
            <div className="m-portlet m-portlet--tabs">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <h3 className="m-portlet__head-text">Box Office</h3>
                  </div>
                </div>
                <div className="m-portlet__head-tools">
                  <ul
                    className="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand  m-tabs-line--right m-tabs-line-danger"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <NavLink
                        exact
                        className="nav-link m-tabs__link"
                        to={"/admin/front-desk"}
                      >
                        <i className="flaticon-interface" />
                        Access Voucher
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                        exact
                        className="nav-link m-tabs__link"
                        to={"/admin/front-desk/search"}
                      >
                        <i className="flaticon-search-magnifier-interface-symbol" />
                        Search
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>

              <Switch>
                <Route
                  exact
                  path="/admin/front-desk"
                  component={BoxOfficeAccessVoucher}
                />
                <Route
                  exact
                  path="/admin/front-desk/search"
                  component={BoxOfficeSearch}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BoxOffice;
